import Immutable from 'immutable'
import {ReduceStore} from 'flux/utils'

import AgrActionTypes from './AgrActionTypes'
import AgrDispatcher from './AgrDispatcher'
import Utils from '../Utils'

class AgrStore extends ReduceStore {

  constructor() {
    super(AgrDispatcher);
  }

  getInitialState() {
    var res = {
      loggedIn: false,
      loginInProgress: false,
      agreements: [],
      activeAgreement: null,
      saving: false,
      hash: Utils.hashToMap(),

      snackMessage: null
    }

    return Immutable.Map(res);
  }

  setSnackState(state, action) {
    var res = {
      snackMessage: action.data.message,
      snackMessageParams: action.data.params,
      snackAction: action.data.action,
      snackActionLabel: action.data.actionLabel
    }

    return state.merge(res)
  }

  //areEqual(a, b) { HACK  return false }

  getUnsignedAgreement(agreements) {
    var unsignedAgreement = null
    agreements.forEach((agr) => {
      if (agr.status === 'blank' && unsignedAgreement === null) {
        unsignedAgreement = agr
      }
    })

    return unsignedAgreement
  }

  reduce(state, action) {
    console.log(state)
    var res = {}

    switch (action.type) {
      case AgrActionTypes.CHANNEL:
        return state.set("hash", action.data)
      case AgrActionTypes.AGREEMENT_SAVING:
        return state.set("saving", action.data)
      case AgrActionTypes.CLEAR_ERROR:
        return state.merge({snackMessage: null})
      case AgrActionTypes.AGREEMENTS_LOADED:
        state = state.set("activeAgreement", this.getUnsignedAgreement(action.data))
        return state.set("agreements", action.data)
      case AgrActionTypes.AGREEMENT_SELECTED:
        return state.set("activeAgreement", action.data)
      case AgrActionTypes.LOGIN:
        return state
      case AgrActionTypes.LOGOUT:
        return this.getInitialState()
      case AgrActionTypes.LOGIN_START:
        return state.merge({loginInProgress: true, snackMessage: null})
      case AgrActionTypes.LOGGED_IN:
        state = state.merge({loggedIn: true, loginInProgress: false});
        state = state.set("login", action.data.login);
        state = state.set("user", action.data.user);
        return state
      case AgrActionTypes.LOGIN_FAILED:
        res = {
          loggedIn: false,
          loginInProgress: false
        }
        return this.setSnackState(state.merge(res), action);
      default:
        return state
    }
  }
}

export default new AgrStore();



// WEBPACK FOOTER //
// ./src/data/AgrStore.js